import { createBrowserHistory } from 'history'

const props = {
  basename: process.env.PUBLIC_URL
}

if (process.env.NODE_ENV === 'test') {
  props.basename = '/'
}

const customHistory = createBrowserHistory(props)

customHistory.listen(location => {
  window.ineum('page', location.pathname)
})

export default customHistory
